module.exports = __webpack_public_path__ + "static/media/mp.aa6f2a40.svg";